import { render } from "./IconLocationMarker.vue?vue&type=template&id=18cb60d2"
import script from "./IconLocationMarker.vue?vue&type=script&lang=js"
export * from "./IconLocationMarker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__